import React from 'react';

const sections = [
  {
    heading: '제1조 (목적)',
    body: [
      '이 약관은 오잉랩(이하 “회사”)이 운영하는 Koready 기업회원 서비스의 이용과 관련하여 회사와 기업회원 사이의 권리, 의무 및 책임사항을 정함을 목적으로 합니다.',
    ],
  },
  {
    heading: '제2조 (정의)',
    body: [
      '① “기업회원”이란 채용, 제휴 또는 사업 서비스를 이용할 목적으로 기업정보를 등록하고 이 약관에 동의한 회원을 말합니다.',
      '② “공고”란 기업회원이 인재를 모집하기 위해 서비스에 게시한 채용정보를 말합니다.',
      '③ “지원자 정보”란 지원자가 공고에 지원하며 제출한 성명, 연락처, 이력서, 첨부서류 및 링크 등의 정보를 말합니다.',
    ],
  },
  {
    heading: '제3조 (약관의 효력 및 변경)',
    body: [
      '① 이 약관은 기업회원이 동의하고 가입을 완료한 때부터 효력이 발생합니다.',
      '② 회사는 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수 있으며, 중요한 변경은 시행일 30일 전부터 서비스 내 공지 또는 전자우편으로 안내합니다.',
    ],
  },
  {
    heading: '제4조 (기업회원 가입)',
    body: [
      '① 기업회원은 회사명, 담당자명, 사업자등록번호 및 회사 소재지 등 회사가 요청하는 정보를 사실대로 입력해야 합니다.',
      '② 회사는 허위 정보 입력, 타인의 정보 도용, 법령 위반 이력 또는 서비스 운영상 중대한 사유가 있는 경우 가입을 거절하거나 사후에 이용을 제한할 수 있습니다.',
    ],
  },
  {
    heading: '제5조 (계정 관리)',
    body: [
      '기업회원은 계정과 비밀번호를 안전하게 관리해야 하며, 계정을 제3자에게 양도·대여하거나 공동으로 사용하게 해서는 안 됩니다.',
    ],
  },
  {
    heading: '제6조 (기업회원 서비스)',
    body: [
      '회사는 기업회원에게 채용공고 등록·관리, 지원자 확인, 지원 결과 관리 및 기타 채용 관련 기능을 제공합니다. 세부 기능은 운영상 필요에 따라 변경될 수 있습니다.',
    ],
  },
  {
    heading: '제7조 (공고 등록 및 관리)',
    body: [
      '① 기업회원은 실제 채용 조건과 일치하는 공고만 게시해야 합니다.',
      '② 모집이 종료되거나 채용 조건이 변경된 경우 기업회원은 공고를 지체 없이 수정하거나 마감해야 합니다.',
      '③ 회사는 공고의 적법성 또는 사실관계 확인을 위해 증빙자료 제출을 요청할 수 있습니다.',
    ],
  },
  {
    heading: '제8조 (기업회원의 의무)',
    body: [
      '① 기업회원은 공고의 회사명, 업무내용, 근무조건, 급여, 근무장소, 고용형태 및 자격요건을 사실대로 기재해야 합니다.',
      '② 기업회원은 지원자 정보를 해당 채용 목적에만 사용해야 하며, 지원자의 동의 또는 법적 근거 없이 제3자에게 제공하거나 영업·마케팅 목적으로 이용해서는 안 됩니다.',
      '③ 기업회원은 채용절차의 공정화에 관한 법률, 직업안정법, 개인정보 보호법 및 기타 관계 법령을 준수해야 합니다.',
      '④ 기업회원은 계정 또는 지원자 정보의 유출·오용을 발견한 경우 즉시 회사에 알려야 합니다.',
    ],
  },
  {
    heading: '제9조 (지원자 정보의 열람)',
    body: [
      '① 지원자 정보는 해당 공고를 작성한 기업회원만 열람할 수 있습니다.',
      '② 기업회원은 내부적으로 채용 업무를 담당하는 최소한의 인원에게만 열람 권한을 부여해야 합니다.',
      '③ 기업회원은 서비스를 통해 확인한 지원자 정보를 별도로 저장한 경우에도 이 약관의 보관기간과 파기 의무를 준수해야 합니다.',
    ],
  },
  {
    heading: '제10조 (지원자 정보의 보관 및 파기)',
    body: [
      '① 합격자의 지원자 정보는 기업회원이 입력한 공식 입사일부터 최대 90일까지 열람할 수 있으며, 해당 기간이 지나면 삭제됩니다.',
      '② 불합격자 및 채용 마감 시까지 합격 처리되지 않은 지원자의 정보는 해당 공고가 마감되는 즉시 삭제됩니다.',
      '③ 기업회원이 별도로 보관한 이력서 또는 첨부서류도 동일한 기준에 따라 복구할 수 없는 방법으로 파기해야 합니다.',
    ],
  },
  {
    heading: '제11조 (금지되는 공고)',
    body: [
      '기업회원은 허위·과장 공고, 차별적 조건을 포함한 공고, 불법 직업소개 또는 금전 요구를 목적으로 하는 공고, 실제 채용 의사가 없는 공고, 관계 법령이나 공공질서에 위반되는 공고를 게시할 수 없습니다.',
    ],
  },
  {
    heading: '제12조 (공고의 심사 및 조치)',
    body: [
      '회사는 신고 또는 모니터링을 통해 위반 가능성이 확인된 공고를 임시 비공개 처리할 수 있으며, 기업회원의 소명을 확인한 후 수정 요청, 게시 중단 또는 삭제 조치를 할 수 있습니다.',
    ],
  },
  {
    heading: '제13조 (지식재산권)',
    body: [
      '기업회원이 작성한 공고 내용의 권리는 해당 기업회원에게 있습니다. 다만 기업회원은 서비스 제공, 공고 노출 및 운영상 필요한 범위에서 회사가 이를 사용할 수 있도록 허락합니다.',
    ],
  },
  {
    heading: '제14조 (서비스 이용료)',
    body: [
      '유료 기능이 제공되는 경우 회사는 이용료, 결제조건 및 환불기준을 결제 전에 별도로 안내합니다.',
    ],
  },
  {
    heading: '제15조 (서비스 변경 및 중단)',
    body: [
      '회사는 점검, 장애, 천재지변 또는 운영상 필요한 사유가 있는 경우 서비스의 전부 또는 일부를 변경하거나 일시 중단할 수 있으며, 가능한 경우 사전에 안내합니다.',
    ],
  },
  {
    heading: '제16조 (계약 해지)',
    body: [
      '기업회원은 언제든지 계정 삭제를 요청할 수 있습니다. 회사는 관련 법령상 보관 의무가 있는 정보를 제외하고 기업회원 정보를 지체 없이 삭제합니다.',
    ],
  },
  {
    heading: '제17조 (이용 제한)',
    body: [
      '회사는 기업회원이 이 약관 또는 관계 법령을 위반한 경우 경고, 공고 비공개, 게시 제한, 계정 정지 또는 이용계약 해지 등의 조치를 할 수 있습니다.',
    ],
  },
  {
    heading: '제18조 (허위·위법 공고에 대한 제재)',
    body: [
      '① 허위 공고는 「직업안정법」 등 관계 법령에 따라 처벌될 수 있습니다.',
      '② 회사는 허위·위법 공고가 확인되거나 합리적으로 의심되는 경우 사전 통지 없이 공고를 중단하고 기업회원의 게시 권한 또는 계정 이용을 제한할 수 있습니다.',
      '③ 기업회원은 허위·위법 공고로 인해 지원자, 회사 또는 제3자에게 발생한 손해에 대해 관계 법령에 따른 책임을 부담합니다.',
    ],
  },
  {
    heading: '제19조 (준거법 및 분쟁 해결)',
    body: [
      '이 약관은 대한민국 법령에 따라 해석되며, 서비스 이용과 관련한 분쟁은 당사자 간 협의를 우선으로 하고 해결되지 않는 경우 관계 법령이 정한 관할법원에서 처리합니다.',
      '오잉랩 | 사업자등록번호 179-45-01005 | 문의 hello@ko-ready.com',
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: '기업회원 이용약관',
  lastUpdated: '2026년 8월 14일',
  effectiveDate: '2026-08-14',
  lastUpdatedLabel: '최종 수정일',
  sections,
};
